import { render, staticRenderFns } from "./SizeCharts.vue?vue&type=template&id=3ee401e6"
import script from "./SizeCharts.vue?vue&type=script&lang=js"
export * from "./SizeCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports